import ContentPageTopButtons from "../../../Components/ContentPageTopButtons";
import ErrorIndicator from "../../../Components/ErrorIndicator";
import LoadingIndicator from "../../../Components/LoadingIndicator";
import { getMemberHeaders, sendCustomEmail } from "../../../services/adminService";
import { AuthContext, AuthContextType, LangContext, LangContextType, LoadingContext, LoadingContextType, OutletContextType, ToastContext, ToastContextType, useAsync } from "../../../utilities/customHooks";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import * as T from "../../../utilities/frontendTypes";
import List, { KeyValuePair } from "../../../Components/List";
import { getLastPartOfPath, isFromUrls } from "../../../utilities/helperFunctions";
import { contentPageContainerStyle, contentPageWrapperStyle } from "../ProfilePages/PartnerAdminList";
import { DetailsContentHeader } from "../ProfilePages/NewAdmin";
import { useContext, useEffect, useState } from "react";
import textData from "../../../textData.json";
import Button, { ButtonProp } from "../../../Components/Button";
import Modal from "../../../Components/Modal";
import { dropdownArrowClasses } from "../../../Components/Form/DropdownSingleSelect";
import { inputClasses } from "../../../Components/Form/InputField";
import Form from "../../../Components/Form/Form";
import { customEmailFormDefinition } from "../../../utilities/formDefinitionTemplates";
import DatePicker from 'react-datepicker';

export const membershipsColumnHeaderData = [
  {
    header: "Company Name",
    key: "companyName"
  },
  {
    header: "Application Date",
    key: "submittedDate"
  },
  {
    header: "Contact Name",
    key: "contact"
  },
  {
    header: "Contact Email",
    key: "email"
  },
  {
    header: "Status",
    key: "founderStatus",
    sortOptions: [],
  },
  {
    header: "Action Item",
    key: "actionItem",
    sortOptions: [
      "Predates Update",
      "Application Unsubmitted",
      "Application Submitted",
      "Application Submitted",
      "Due Diligence in Progress",
      "Application Edit Requested",
      "Rejection Flagged",
      "Rejection In Progress",
      "Application Rejected",
      "Re-apply Requested",
      "Awaiting IPE/GC",
      "Awaiting IPE/GC",
      "Awaiting IPE Invite",
      "Awaiting GC Assignment",
      "Awaiting GC Review",
      "GC Assessment Ready",
      "IPE Invite Sent",
      "IPE Board Review",
      "IPE Assement Underway",
      "IPE Assessment Ready",
      "IPE Requests Due Diligence",
      "Confirm Service Provider",
      "New Service Provider Requested",
      "SoW Requested",
      "Startup Approval Requested",
      "SoW Approval",
      "SoW Approval",
      "SoW Edits Requested",
      "SoW Ready for Signature",
      "Working with Service Provider",
    ],
  },
  {
    header: "Cohort",
    key: "cohort"
  },
  {
    header: "Persona Score",
    key: "personaScore"
  },
  {
    header: "GC Status",
    key: "gcStatus",
    sortOptions: ["Invited", "No Concerns", "Decline", "N/A"]
  },
  {
    header: "Account Owner",
    key: "owner"
  },
  {
    header: "IPE Status",
    key: "ipe",
    sortOptions: ["Not Invited", "Invite Sent", "In Progress", "IPE Request Due Diligence", "IPE Recommendation Ready", "Recommended", "Not Recommended"],
  },
  {
    header: "IPE",
    key: "ipeName"
  },
]

function MembersList() {
  const currentDate = new Date()
  const { langState } = useContext(LangContext) as LangContextType
  const showToast = (useContext(ToastContext) as ToastContextType).showToast;
  const {showLoading, hideLoading} = useContext(LoadingContext) as LoadingContextType;
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedUsers, setSelectedUsers] = useState<string[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalHtml, setModalHtml] = useState(<></>)
  const [modalHTMLPage, setModalHtmlPage] = useState("")
  const [currentFilteredHeaders, setCurrentFilteredHeaders] = useState<T.MemberHeader[]>([])
  const [usingFilter, setUsingFilter] = useState(false)
  const [filtersObj, setFiltersObj] = useState({
    ownedByQuerier: false,
    minPersonaScore: 0,
    status: "All",
    ipeStatus: "All",
    cohort: 0,
    maxDate: currentDate,
    minDate: new Date("2023-01-01")
  })
  const [reloadOnOutletSave, setReloadOnOutletSave] = useState(false);
  const [reloadModal, setReloadModal] = useState(false);

  const { logout } = useContext(AuthContext) as AuthContextType;
  const handleViewMemberDetails = (appId: T.UserId) => {
    navigate((`/dashboard/memberships/${appId}`));
  }

  const handleApplyFilters = () => {
    const toFilter = currentFilteredHeaders
    const filterArray = () => {
      const result = toFilter.filter(obj => {
        // Check personaScore conditions
        if (filtersObj.minPersonaScore > 0) {
        if (!obj.hasOwnProperty('personaScore')) return false;
        if (obj.personaScore === "N/A") return false;
        if (parseFloat(obj.personaScore) < filtersObj.minPersonaScore) return false;
        }

        if (filtersObj.status !== "All") {
          if (!obj.hasOwnProperty('founderStatus') || obj.founderStatus !== filtersObj.status) {
            return false;
          } else {
          }
        }

        if (filtersObj.ipeStatus !== "All") {
          if (!obj.hasOwnProperty('ipeStatus') || obj.ipe !== filtersObj.ipeStatus) return false;
        }

        if (filtersObj.cohort !== 0) {
          if (!obj.hasOwnProperty('cohort') || obj.cohort !== filtersObj.cohort) return false;
        }

        if (filtersObj.maxDate && filtersObj.minDate){
          if (obj.appDate) {
            if (obj.appDate < filtersObj.minDate || obj.appDate > filtersObj.maxDate) return false;
          }
        }
        return true;
      });
      setCurrentFilteredHeaders(result);
    };
    filterArray()
    setIsModalOpen(false)
    setReloadOnOutletSave(!reloadOnOutletSave)
  }

  const handleReset = () => {
    setFiltersObj({
      ownedByQuerier: false,
      minPersonaScore: 0,
      status: "All",
      ipeStatus: "All",
      cohort: 0,
      maxDate: currentDate,
      minDate: new Date("2023-01-01")
    })
    setIsModalOpen(false)
    setUsingFilter(false)
    setReloadOnOutletSave(!reloadOnOutletSave)
  }

  const handlePersonaChange = (event: { target: { value: string; }; }) => {
    const inputValue = event.target.value;
    const toFilter = filtersObj
    toFilter.minPersonaScore = parseFloat(inputValue)
    setFiltersObj(toFilter)
    setReloadModal(!reloadModal)
  };

  const handleCohortChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10);
    const toFilter = filtersObj
    toFilter.cohort = value
    setFiltersObj(toFilter)
    setReloadModal(!reloadModal)
  };

  const handleStatusChange = (event: { target: { value: string; }; }) => {
    const inputValue = event.target.value;
    const toFilter = filtersObj
    toFilter.status = inputValue
    setFiltersObj(toFilter)
    setReloadModal(!reloadModal)
  };

  const handleIpeStatusChange = (event: { target: { value: string; }; }) => {
    const inputValue = event.target.value;
    const toFilter = filtersObj
    toFilter.ipeStatus = inputValue
    setFiltersObj(toFilter)
    setReloadModal(!reloadModal)
  };

  const handleMaxDateChange = (date: Date | null) => {
    if (date) {
    const toFilter = filtersObj
    toFilter.minDate = date
    setFiltersObj(toFilter)
    setReloadModal(!reloadModal)
    };
  }

  const handleMinDateChange = (date: Date | null) => {
    if (date) {
    const toFilter = filtersObj
    toFilter.minDate = date
    setFiltersObj(toFilter)
    setReloadModal(!reloadModal)
    };
  }

  useEffect (() => {
    const tempModalHtml = (
      <div>
        {modalHTMLPage === "filter" &&
        <div className="flex flex-col p-4 gap-8 w-full filterModal">
          <h4>Select Filters</h4>
          <div className="flex flex-col w-full">
            <div className="relative mb-5 w-full flex items-center gap-8 justify-between">
              <p className="bodyLarger">Min Persona Score:</p>
              <select 
                id="personaScoreDropdown" 
                value={filtersObj.minPersonaScore} 
                onChange={handlePersonaChange}
                className={inputClasses}
              >
                <option value="0">0</option>
                <option value="0.5">0.5</option>
                <option value="1.5">1.5</option>
                <option value="2">2</option>
                <option value="2.5">2.5</option>
                <option value="3">3</option>
                <option value="3.5">3.5</option>
                <option value="4">4</option>
              </select>
              <span className={dropdownArrowClasses}></span>
            </div>
            <div className="relative mb-5 w-full flex items-center gap-8 justify-between">
              <p className="bodyLarger">Status:</p>
              <select 
                id="statusDropdown" 
                value={filtersObj.status} 
                onChange={handleStatusChange}
                className={inputClasses}
              >
                <option value="All">All</option>
                <option value="Application Unsubmitted">Application Unsubmitted</option>
                <option value="Application Submitted">Application Submitted</option>
                <option value="Due Diligence in Progress">Due Diligence in Progress</option>
                <option value="Due Diligence Pending">Due Diligence Pending</option>
                <option value="Application Rejected">Application Rejected</option>
                <option value="Re-apply Requested">Re-apply Requested</option>
                <option value="Awaiting IPE Invite">Awaiting IPE Invite</option>
                <option value="Awaiting GC Review">Awaiting GC Review</option>
                <option value="GC Assessment Ready">GC Assessment Ready</option>
                <option value="IPE Invite Sent">IPE Invite Sent</option>
                <option value="IPE Assessment Underway">IPE Assessment Underway</option>
                <option value="IPE Assessment Ready">IPE Assessment Ready</option>
                <option value="IPE Requests Due Diligence">IPE Requests Due Diligence</option>
                <option value="Working With Service Provider">Working With Service Provider</option>
                <option value="Predates Update">Predates Update</option>
              </select>
              <span className={dropdownArrowClasses}></span>
            </div>
            <div className="relative mb-5 w-full flex items-center gap-8 justify-between">
              <p className="bodyLarger">IPE Status:</p>
              <select 
                id="statusDropdown" 
                value={filtersObj.ipeStatus} 
                onChange={handleIpeStatusChange}
                className={inputClasses}
              >
                <option value="All">All</option>
                <option value="Not Invited">Not Invited</option>
                <option value="Invite Sent">Invite Sent</option>
                <option value="In Progress">In Progress</option>
                <option value="IPE Request Due Diligence">IPE Request Due Diligence</option>
                <option value="IPE Recommendation Ready">IPE Recommendation Ready</option>
                <option value="Recommended">Recommended</option>
                <option value="Not Recommended">Not Recommended</option>
              </select>
              <span className={dropdownArrowClasses}></span>
            </div>
            <div className="relative mb-5 w-full flex items-center gap-8 justify-between">
              <p className="bodyLarger">{`Cohort (0 returns all Cohort)`}</p>
              <input 
                id="cohortInput"
                type="number" 
                value={filtersObj.cohort} 
                onChange={handleCohortChange}
                className={inputClasses}
              />
            </div>
            <div className="relative mb-5 w-full flex items-center gap-8 justify-between">
              <p className="bodyLarger">Min Application Date</p>
              <DatePicker 
                className={inputClasses }
                selected={filtersObj.maxDate}
                id={"MinDate"}
                scrollableYearDropdown={true}
                showYearDropdown
                yearDropdownItemNumber={115}
                onChange={handleMinDateChange}
                maxDate={currentDate}
              /> 
            </div>
            <div className="relative mb-5 w-full flex items-center gap-8 justify-between">
              <p className="bodyLarger">Max Application Date</p>
              <DatePicker 
                className={inputClasses }
                selected={filtersObj.maxDate}
                id={"MinDate"}
                scrollableYearDropdown={true}
                showYearDropdown
                yearDropdownItemNumber={115}
                onChange={handleMaxDateChange}
                maxDate={currentDate}
              /> 
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <Button
              buttonText="Apply Filters"
              buttonType="primaryFull"
              actionHandler={() => handleApplyFilters()}
            />
            <Button 
              buttonText="Reset All"
              buttonType="secondaryFull"
              actionHandler={() => handleReset()}
            />
          </div>
        </div>
      }
      {
        modalHTMLPage === "email" &&
        <div>
          <Form
            formDefinition={customEmailFormDefinition}
            primaryButtonProp={customEmailPrimaryButtonProp}
            formData={null}
          />
        </div>
      }
    </div>
    )
    setModalHtml(tempModalHtml)
  }, [filtersObj, isModalOpen, reloadModal])
  
  const memberHeadersAsync = useAsync(() => getMemberHeaders(), [reloadOnOutletSave]);

  if (memberHeadersAsync.status === "pending") {
    return <LoadingIndicator />;
  }

  if (memberHeadersAsync.status === "rejected") {
    return <ErrorIndicator />;
  }

  const memberHeaders = memberHeadersAsync.value.memberHeaders.reverse();

  const myAccountsText = filtersObj.ownedByQuerier ? "All Accounts" : "My Accounts"
  const emailArrayChange = (array: string[]) => {
    let ids: string[] = []
    array.forEach(string => {
      memberHeaders.forEach(obj => {
        if (obj.companyName === string) {
          ids.push(obj.appId);
        }
      });
    });
    setSelectedUsers(ids)
  }

  const handleShowFilter = () => {
    setCurrentFilteredHeaders(memberHeaders)
    setModalHtmlPage("filter")
    setUsingFilter(true)
    setIsModalOpen(true)
  }

  const handleCustomEmail = async (tempupdatedForm: FormData) => {
    const tempMessage = tempupdatedForm as any
    const respondTo = tempMessage.respondTo
    const messageString = tempMessage.customMessage

    showLoading();
    const response = await sendCustomEmail(messageString, selectedUsers, respondTo);
    hideLoading();

    if (!response) {
      showToast({
        toastType: "failure",
        message: "Unable to send Custom Email.  Please try again and if issue persists contact support.",
        autoDisappearTimeInSeconds: 8,
      })
    } else {
      setIsModalOpen(false);
      setSelectedUsers([])
      showToast({
        toastType: "success",
        message: "Custom Email Sent!",
        autoDisappearTimeInSeconds: 8,
      });
    }
  }

  const customEmailPrimaryButtonProp: ButtonProp = {
    buttonText: "Send Custom Email",
    actionHandler: handleCustomEmail
  }

  const handleSendEmail = () => {
    setModalHtmlPage("email")
    setIsModalOpen(true)
  }

  const accountFilter = () => {
    setUsingFilter(!usingFilter)
    const toFilter = filtersObj
    toFilter.ownedByQuerier = !filtersObj.ownedByQuerier
    const toArrayFilter = currentFilteredHeaders.length === 0 ? memberHeaders : currentFilteredHeaders
    // const toArrayFilter = memberHeaders
    setCurrentFilteredHeaders(toArrayFilter.filter(member => member.ownedByQuerier === toFilter.ownedByQuerier))
    setFiltersObj(toFilter)
    setReloadOnOutletSave(!reloadOnOutletSave)
  }

  const listHtml = (
    <div className="w-fit memDeatilsList">
      <List 
        contentArray={!usingFilter ? memberHeaders as KeyValuePair[] : currentFilteredHeaders as KeyValuePair[]}
        columnHeaderData={membershipsColumnHeaderData}
        returnDetailsId={handleViewMemberDetails}
        detailsIdName="appId"
        listHighlightId={getLastPartOfPath(location.pathname)}
        deaultSortByKey={"submittedDate"}
        defaulSortOrderArrayPosition={1}
        defaultAscending={true}
        checkbox
        emailArrayChange={emailArrayChange}
      />
    </div>
  )


  return (
    <div>
      <div className="flex flex-col sticky memDeatilsStickyHeader">
      <header className="dashboardHeader ">
        <div className='headerSect'>
          <button 
            className='flex bodyLarger buttonSizer'
            onClick={logout}
          >
            <svg className='mr-2' xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none"><path d="M2.60117 12.6826L2.62197 12.7105L2.62194 12.7105C3.31089 13.6256 4.21794 14.3783 5.26877 14.8979C6.29021 15.403 7.45043 15.6879 8.68188 15.6879C10.7469 15.6879 12.616 14.8831 13.9688 13.5821C15.3215 12.2811 16.1575 10.4843 16.1575 8.50003C16.1575 6.51571 15.3214 4.71894 13.9688 3.41797C12.616 2.11692 10.7469 1.31213 8.68188 1.31213C7.45417 1.31213 6.29756 1.59507 5.27926 2.09609C4.22058 2.61748 3.30739 3.37501 2.61589 4.29603C2.47204 4.48838 2.19528 4.53117 1.99654 4.39366C1.7966 4.25534 1.75032 3.98628 1.89506 3.79278L1.89513 3.7927C2.66968 2.76184 3.69136 1.91429 4.87674 1.33069C6.02011 0.767551 7.31393 0.45 8.68198 0.45C10.9922 0.45 13.0844 1.3506 14.5986 2.80692L14.5986 2.80692C16.1128 4.26383 17.05 6.27677 17.05 8.5C17.05 10.7236 16.1128 12.7367 14.5986 14.1931L14.5986 14.1931C13.0838 15.6494 10.9917 16.55 8.68198 16.55C7.30756 16.55 6.00899 16.2298 4.86243 15.6631C3.6733 15.0754 2.65003 14.2223 1.8771 13.1858L1.87704 13.1857C1.73295 12.9917 1.77975 12.7217 1.98023 12.5834C2.17965 12.4458 2.45741 12.4898 2.60117 12.6826ZM1.08524 8.18019L1.11158 8.15552L3.75033 5.61765C3.9241 5.44997 4.20534 5.45004 4.37955 5.61756C4.55497 5.78575 4.55487 6.05954 4.37958 6.22813L4.34492 6.19209L4.37957 6.22813L2.47601 8.05837H11.5025C11.7472 8.05837 11.9485 8.24931 11.9485 8.48921C11.9485 8.72918 11.7471 8.92005 11.5025 8.92005H2.47599L4.37952 10.7508C4.55495 10.919 4.55488 11.1927 4.37964 11.3613C4.20586 11.529 3.9246 11.5289 3.75039 11.3614L1.08524 8.79814C1.08516 8.79807 1.08508 8.79799 1.085 8.79791C1.06218 8.7765 1.04208 8.75257 1.02468 8.72795L1.0243 8.72822L1.02255 8.72485L1.01816 8.71829L1.0134 8.71117L1.01314 8.71134L1.01082 8.70687C0.972479 8.64331 0.950001 8.56882 0.950001 8.48917C0.950001 8.40969 0.972374 8.33537 1.01055 8.2719L1.01031 8.27177L1.0134 8.26716L1.01816 8.26005L1.01717 8.25938L1.02099 8.25572L1.02438 8.2508C1.04224 8.22498 1.06258 8.20142 1.08524 8.18019Z" fill="#1A2E25" stroke="#1A2E25" strokeWidth="0.1"/></svg>
            <span className="relative">Logout</span>
          </button>
        </div>
      </header>
      <div className="flex justify-between pr-6">
        <h2>All Startups</h2>
        <div className="flex gap-6">
          <Button 
            buttonType="secondary"
            buttonText="Send Email"
            disabled={selectedUsers.length === 0}
            actionHandler={() => handleSendEmail()}
          />
          <Button 
            buttonType="primary"
            buttonText={myAccountsText}
            actionHandler={() => accountFilter()}

          />
          <Button 
            buttonType="secondary"
            buttonText="All Filters"
            disabled={filtersObj.ownedByQuerier}
            actionHandler={() => handleShowFilter()}
          />
        </div>
      </div>
    </div>
    <div className="resourcesCont !pt-0 !w-fit">
      {listHtml}
      <Modal 
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        modalHeader={``}
        contentLabel={``}
        modalHTML={modalHtml}
      />
    </div>  
  </div>
  )
}

export default MembersList

